
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inkinds/sitemap",
      function () {
        return require("private-next-pages/inkinds/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inkinds/sitemap"])
      });
    }
  